export class ContractFinalizeDto {
	TIME: Date;
	codContrato: string;
	detalhesDasEntregas: string;
	rastreio: string;
	status: string;
	title: string;
	valorFinal: string;
}
